import type { CrossChainGasCosts } from './types';

/**
 * Total origin-chain network fee from a cross-chain quote's gas costs, in
 * native base units (wei for EVM, lamports for SVM).
 *
 * The 0x cross-chain API reports this under different field names depending on
 * the origin chain type — `totalNetworkFee` for EVM, `total` for SVM — so this
 * helper normalises access for the fee-display, balance-coverage, and
 * fee-reserve code paths. The quote payload is not schema-validated on the way
 * in, so this tolerates a missing `gasCosts` (returns `0n`) and missing fee
 * fields (`?? '0'`) rather than throwing in a render/compute path.
 */
export const getCrossChainGasFee = (gasCosts: CrossChainGasCosts | null | undefined): bigint => {
  if (!gasCosts) return 0n;

  return gasCosts.chainType === 'svm'
    ? BigInt(gasCosts.total ?? '0')
    : BigInt(gasCosts.totalNetworkFee ?? '0');
};
